import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { FahrzeugListView } from "./list-view/fahrzeug.list-view";

export const fahrzeugFieldOk: FieldOkConfig = {
  name: 'fahrzeug',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fahrzeug}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: FahrzeugListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};
export const fahrzeugMultiselectFieldOk: FieldOkConfig = {
  name: 'fahrzeug',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fahrzeug}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: FahrzeugListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};

export const fahrzeugQueryFieldOk: FieldOkConfig = {
  name: 'fahrzeug',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fahrzeug}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: FahrzeugListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};
